import CustomCurrencyIcon from './CustomCurrencyIcon';

export default CustomCurrencyIcon;
